import Page from "webPage/Page";
import ProjectsLoader from "util/ProjectsLoader";

Page.register(['post-type-archive-projects', 'tax-sector'], () => {

    let $projects = $('.js-projects');
    if($projects.length > 0) {
        $projects.each(function () {
           new ProjectsLoader($(this));
        });
    }

});
